import Agent from 'infrastructure/agent';
import activityLogMappers from 'features/wells/overview/activityLog/helpers/activityLog.mappers';

const upsertActivityLog = (wellId, activity, activityLogId = null) =>
  Agent.post(
    `/IntegrityManagementActivityLog/well/${wellId}`,
    activityLogMappers.activities.upsert(activity, activityLogId),
  );

const getIntegrityUsersByOrganization = () =>
  Agent.get('/IntegrityManagementUser/by-organization');

const filterActivityLogs = (wellId, filters) =>
  Agent.post(`/IntegrityManagementActivityLog/search/well/${wellId}`, filters);

const filterFieldActivityLogs = (fieldId, filters) =>
  Agent.post(
    `/IntegrityManagementActivityLog/search/field/${fieldId}`,
    filters,
  );

const deleteActivityLog = (activityLogId) =>
  Agent.delete(`/IntegrityManagementActivityLog/${activityLogId}`);

const activityLogService = {
  upsertActivityLog,
  getIntegrityUsersByOrganization,
  filterActivityLogs,
  deleteActivityLog,
  filterFieldActivityLogs,
};

export default activityLogService;
